<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="新建知识库结构"></pt-page-title>
    <pt-detection-corpus-structure-form ref="child" @updateLoading="updateLoading"></pt-detection-corpus-structure-form>
    <div class="marginTop">
    <el-button type="primary" @click="create">新建</el-button>
    <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import ptDetectionCorpusStructureForm from '../pt-detection-corpus-structure-form/withData'
const prefixCls = 'pt-detection-corpus-structure-new'

export default {
  name: 'pt-detection-corpus-structure-new',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptDetectionCorpusStructureForm
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    create () {
      this.$refs.child.submit()
      // .then(() => {
      //   this.$message.success('新建成功!')
      //   this.$router.push({ name: 'product-list', params: { type: this.type } })
      //   this.loading = false
      // }).catch((error) => {
      //   console.error(error)
      //   this.loading = false
      //   this.$message.error('新建产品失败！' + error)
      // })
    },
    updateLoading (val) {
      this.loading = val
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
